export default {"src":"/_next/static/media/pax.9926e994.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};